import { CampaignBody } from "@vviinn/user-managment-client-ts";
import { TextSearchNumbericTitles } from "./types";
import { typecastedTextSearch } from "./typecastedTextSearch";
import { HandleChangeValue } from "../types";

export const handleTextSearchConfig = (
  newConfig: CampaignBody,
  key: keyof TextSearchNumbericTitles,
  isSameValue: boolean,
  newValue: HandleChangeValue,
) => {
  const updatedConfigData = typecastedTextSearch(key, newConfig, isSameValue);
  if (updatedConfigData) {
    const { typecastedEntity, parentKey, typecastedKey } = updatedConfigData;

    if (!isSameValue) {
      newConfig = {
        ...newConfig,
        [parentKey]: {
          ...typecastedEntity,
          [typecastedKey]: newValue,
        },
      };
    }
  }
  return newConfig;
};
